import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface RequestForQuoteApiParameter extends ApiParameter {
    requestForQuoteForm: Partial<RequestForQuoteFormApiModel>;
}

export interface RequestForQuoteFormApiModel extends ApiParameter {
    FirstName: string;
    LastName: string;
    Company: string;
    Supplier: string;
    Model: string;
    State: string;
    ZIP: string;
    Phone: string;
    Email: string;
    AdditionalDetailsInquiry: string;
}
const customUrl = "/api/requestforquote/sendemail";

// eslint-disable-next-line require-await
export async function requestForQuoteService(parameter: RequestForQuoteApiParameter): Promise<ServiceResult<RequestForQuoteApiParameter>> {
    const data = {
        FirstName: parameter.requestForQuoteForm.FirstName,
        LastName: parameter.requestForQuoteForm.LastName,
        Company: parameter.requestForQuoteForm.Company,
        Supplier: parameter.requestForQuoteForm.Supplier,
        Model: parameter.requestForQuoteForm.Model,
        State: parameter.requestForQuoteForm.State,
        ZIP: parameter.requestForQuoteForm.ZIP,
        Phone: parameter.requestForQuoteForm.Phone,
        Email: parameter.requestForQuoteForm.Email,
        AdditionalDetailsInquiry: parameter.requestForQuoteForm.AdditionalDetailsInquiry,
    };
    const formData = new FormData();
    formData.append("Data", JSON.stringify(data));
    return request<ServiceResult<RequestForQuoteApiParameter>>(customUrl, "POST", {}, formData);
}
